// import { produce } from 'immer'
import { Reducer } from 'redux'
import { StudentState, StudentTypes } from './types'

import { AuthTypes } from '../auth/types'

const INITIAL_STATE: StudentState | null | undefined = {
  profile: null,
}

const reducer: Reducer<StudentState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.SIGN_IN_SUCCESS:
      return { ...state, profile: action.payload.profile }

    case AuthTypes.SIGN_OUT:
      return { ...state, profile: null }

    case StudentTypes.EDIT_STUDENT:
      return { ...state, profile: action.payload }

    case StudentTypes.EDIT_STUDENT_PREFERENCE:
      return { ...state, profile: { ...state.profile, preference: action.payload } }

    case StudentTypes.EDIT_STUDENT_IDENTIFICATION:
      return {
        ...state,
        profile: action.payload,
      }

    default:
      return state
  }
}

export default reducer
